<template>
  <div>
    <label-tag :tagArray="[`${$t('conversation_edit')}(${tagName})`]"/>
    <div class="m-5" style="overflow: auto; min-height:50vh" >
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th style="width:10%">{{$t('selected_character')}}</th>
            <th style="width:90%">{{$t('dialogue')}}</th>
          </tr>
        </thead>
        <br>
        <tbody v-if="dialogsInfo" style="border-top:1px #cccccc solid;border-bottom:1px #cccccc solid;">
          <tr  v-for="(item, index) in dialogsInfo.sentences" :key="index">
            <td style="width:10%">
              <toggle-button v-model="item.isPlayer"
                :sync="true"
                :labels="{checked: locale==='tw'?'主角':'Avatar', unchecked:  locale==='tw'?dialogsInfo.roleName:dialogsInfo.roleNameEn}"
                :color="{checked: '#5dceb0', unchecked: '#6e817f'}"
                :width="140"
                />
            </td>
            <td style="width:100%" class="d-flex">
              <!-- <input style="width:100%" onkeyup="value=value.replace(/[^a-zA-Z\.\?\,\!\;\ \/]/ig,'')"  placeholder="建立課程內容時，請使用英文字母(a-z)和半行符號(「 , 」「 . 」「 ; 」「 ! 」「 ? 」 )" maxlength="100" v-model="item.text" type="text"></input> -->
              <input style="width:100%" onkeyup="value=value.replace(/[^a-zA-Z\.\?\,\!\;\ \/]/ig,'')"  :placeholder="$t('symbols_rules')" maxlength="100" v-model="item.text" type="text">
              <div class="d-flex align-items-center" style="width:20%">
                <div class="px-2">{{item.text.length}}/100</div>
                <div @click="removeContent" class="pointer control-btn px-2">{{$t('delete')}}</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="text-align: left;">
        <button type="button" @click="addSentences" class="btn btn-primary">{{$t('add')}}</button>
      </div>
    </div>
    <div class="mx-5" style="text-align: right;">
      <button type="button" @click="reset" class="btn btn-primary">{{$t('cancel')}}</button>
      <button type="button" @click="editContent" class="btn btn-primary">{{$t('save')}}</button>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import swal from 'bootstrap-sweetalert'
import api from '../../../store/api'
import labelTag from './Label'
export default {

  name: 'Conversation_edit',

  data () {
    return {
      locale: window.localStorage.getItem('locale'),
      dialogsInfo: null,
      tagName: '',
      sentencesLength: 30
    }
  },
  components: {
    labelTag,
    ToggleButton
  },
  mounted () {
    this.getContent()
  },
  methods: {
    async getContent () {
      const { data } = await api.get(`/VR/CustomDialogs/${this.$route.params.id}/Content`)
      this.dialogsInfo = data.data
      if (this.locale === 'tw') {
        this.tagName = `${data.data.title} ${data.data.situationName}`
      } else {
        this.tagName = `${data.data.title} ${data.data.situationNameEn}`
      }
    },
    addSentences () {
      let sentences = {
        isPlayer: true,
        text: ''
      }
      if (this.dialogsInfo.sentences.length < this.sentencesLength) {
        this.dialogsInfo.sentences.push(sentences)
      }
    },
    async editContent () {
      const { data } = await api.patch(`/VR/CustomDialogs/${this.$route.params.id}/Content`, this.dialogsInfo.sentences)
      console.log(data)
      swal(this.$t('saved_successfully') + '!', this.$t('added_mission'), 'success')
      this.getContent()
    },
    removeContent () {
      this.dialogsInfo.sentences.pop()
    },
    reset () {
      this.getContent()
    }
  }
}
</script>

<style lang="scss" scoped>
  table {
    text-align: left;
    select, input {
      height: 2rem;
      min-width: 80px;
    }
  }
  select, input {
    border: rgba(0, 0, 0, 0.205) 1px solid;
    border-radius: 4px;
    outline: none;
    padding: 2px;
  }
  .control-btn {
    color: red;
    text-decoration: underline;
  }


</style>


// WEBPACK FOOTER //
// ConversationEdit.vue?78e386b8